module.exports = __webpack_public_path__ + "img/friend-1.ff73e401.png";